import dayjs from "dayjs";

type ToLocaleIsoString = {
  isoDateString: string;
  format: string;
};

export const toLocaleIsoString = ({
  isoDateString,
  format = "YYYY-MM-DDTHH:mm:ss",
}: ToLocaleIsoString) => {
  const date = dayjs(isoDateString);

  return date.format(format);
};
